export default "__VITE_ASSET__894d4068__"